import { createContext, useContext, useMemo } from "react";

import { createCosmosClient, type CosmosClient } from "./cosmos-client";

const CosmosClientContext = createContext<CosmosClient | undefined>(undefined);
interface CosmosProviderProps {
  checkoutId: string;
  checkoutToken: string;
  checkoutSeon: string;
  children: React.ReactNode;
}

export const CosmosProvider = ({
  checkoutId,
  checkoutToken,
  checkoutSeon,
  children,
}: CosmosProviderProps) => {
  const client = useMemo(
    () =>
      createCosmosClient({
        checkoutId,
        authToken: checkoutToken,
        deviceFingerprint: {
          seonEnabled: true,
          seonSession: checkoutSeon,
        },
      }),
    [checkoutId, checkoutToken, checkoutSeon],
  );

  return (
    <CosmosClientContext.Provider value={client}>
      {children}
    </CosmosClientContext.Provider>
  );
};

export const useCosmosClient = (): CosmosClient => {
  const client = useContext(CosmosClientContext);
  if (!client) {
    throw new Error("`useCosmosClient` must be used within a `CosmosProvider`");
  }
  return client;
};
